import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@rozman/shared';

/**
 * Every internal link carries the locale, so `/pl/…` and `/uk/…` are both linkable and
 * indexable. Nothing in this app builds a path by hand.
 */
export function useLocalePath(): (path: string) => string {
  const { i18n } = useTranslation();
  const locale = i18n.language as Locale;
  return useCallback((path: string) => `/${locale}${path.startsWith('/') ? path : `/${path}`}`, [locale]);
}

export function useLocale(): Locale {
  const { i18n } = useTranslation();
  return (i18n.language as Locale) ?? 'pl';
}
